export default [
  'Bajo',
  'Medio',
  'Alto'
]